import EventEmitter from "eventemitter3";
import Events from "../events/Events.js";


export default class LayoutReactivePoint extends EventEmitter
{

    constructor(x,y, handle)
    {
        super();

        this.pt = {x, y}
        this.handle = handle;
    }

    get x ()
    {
        return this.pt.x;
    }

    set x (val)
    {
        this.pt.x = val;

        this.emit(Events.ReactivePoint,val, this.pt, this.handle, "x", this)
    }

    get y ()
    {
        return this.pt.y;
    }

    set y (val)
    {
        this.pt.y = val;

        this.emit(Events.ReactivePoint,val, this.pt, this.handle, "y", this)
    }
}
